import {ClientRect} from '@dnd-kit/core';

import * as PanelTypes from '../../state/views/panel/types';
import * as PanelBankSectionConfigTypes from '../../state/views/panelBankSectionConfig/types';

/**
 * With the current ref system, we need to continue to use the id from the sectionRef
 * because we are reordering the sectionRefs inside panelBankConfig.
 *
 * While section.__id__ is a stable id, we cannot use this as the unique identifier with the
 * current ref system.
 *
 * @param sectionRef
 * @returns The id of the sectionRef
 */
export const getDndSortableSectionId = (
  sectionRef: PanelBankSectionConfigTypes.Ref
) => {
  return sectionRef.id;
};

/**
 * With the current ref system, we need to continue to use the id from the panelRef
 * because we are reordering the panelRefs inside panelBankConfig.
 *
 * While panel.__id__ is a stable id, we cannot use this as the unique identifier with the
 * current ref system.
 *
 * @param panelRef
 * @returns The id of the panelRef
 */
export const getDndSortablePanelId = (panelRef: PanelTypes.Ref) => {
  return panelRef.id;
};

// Note: panel drop indicator logic relies on this 16px margin between panels.
// please update that logic if we are changing the default section gap.
export const DEFAULT_SECTION_GAP = 16;
export const WORKSPACE_MARGIN_X_TW = 'mx-16';

export const PANEL_VERTICAL_DROP_INDICATOR_WIDTH = 2;
export const PANEL_VERTICAL_DROP_INDICATOR_WIDTH_TW = 'w-2';

export const getWorkspaceDropIndicatorPosition = (
  activeRect: ClientRect,
  overRect: ClientRect
) => {
  // Get the center of the target section to determine which side of the
  // panel user is trying to drop the panel to
  const targetCenterX = overRect.left + overRect.width / 2;
  const activeX = activeRect.left + activeRect.width / 2;
  const isRightSide = activeX > targetCenterX;

  // We want the vertical drop indicator to be centered between the gap between panels
  // There's a 16px gap between panels and on the side and we need to account for the 4px indicator width
  const xPosition = isRightSide
    ? overRect.right +
      DEFAULT_SECTION_GAP / 2 -
      PANEL_VERTICAL_DROP_INDICATOR_WIDTH / 2
    : overRect.left -
      DEFAULT_SECTION_GAP / 2 -
      PANEL_VERTICAL_DROP_INDICATOR_WIDTH / 2;
  const yPosition = overRect.top;

  return {
    isRightSide,
    xPosition,
    yPosition,
  };
};
